import React from 'react';

import { SUMMARY_TYPE_IDS } from 'reducers/mySummaryViewSlice';
import { PROFILE_PAGE_SUMMARY_TYPE_CARDS } from 'screens/home/summary/components/MySummaryContainer';
import { SUMMARY_TYPE_MODULES } from 'screens/home/summary/constants';

const ProfileSummaryContainer = ({ employeeId = null }) => {
  const APPLICABLE_SUMMARY_TYPES = SUMMARY_TYPE_MODULES[SUMMARY_TYPE_IDS.ALL].filter(({ moduleEnabled }) =>
    moduleEnabled()
  );

  if (!APPLICABLE_SUMMARY_TYPES?.length) {
    return <p>No my summary modules</p>;
  }

  return (
    <>
      {APPLICABLE_SUMMARY_TYPES?.map(({ module }, index) => {
        const CardComponent = PROFILE_PAGE_SUMMARY_TYPE_CARDS[module];
        if (CardComponent) {
          return <CardComponent key={`${module}-card-${index}-profile`} employeeId={employeeId} />;
        }
      })}
    </>
  );
};

export default ProfileSummaryContainer;
